import { Button } from "@asosteam/asos-web-component-library-button";
import DisappointedEmoji from "../../assets/disappointed-emoji.svg";
import PropTypes from "prop-types";
import styles from "./styles";

export const ErrorPage = ({ title, description, buttonText, onClick }) => (
  <div className={styles.container}>
    <DisappointedEmoji />
    <h1 className="app_barnsley5">{title}</h1>
    <p className="app_leavesden2">{description}</p>
    <Button onClick={onClick}>{buttonText}</Button>
  </div>
);

ErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
